//Collections
PJQ.collections.projects.Scopes = PJQ.collections.BaseCollection.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'scopes'
            }
        ])
    }
});

//Views
PJQ.views.projectScopes = {};
PJQ.views.projectScopes.CopyScopesFromProjectModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Copy-Scopes-From-Project'),
        maxWidth: '725px',
        onCancel: _.noop,
        onCopy: _.noop
    },
    events: {
        "click .copy-scopes-cancel": "onCancel",
        "click .copy-scopes-save": "onCopy",
    },
    beforeRender: function () {
        this.renderData = {
        }
    },
    afterRender: function () {
        new PJQ.views.projects.ProjectSelector({
            el: this.$('.project-selector'),
            excludeProjectIds: [PJQ.app.session.project.id],
            isSingleChoice: true,
            onProjectSelected: _.bind(function (projects) {
                this.selectedProject = projects;
                this.$('.copy-scopes-save').prop('disabled', _.size(this.selectedProject) === 0 || !this.selectedProject.get('isSelected'));
            }, this),
            dataTableHeaderData: {
                isHideDeletedFilter: true
            },
            dataTableColumns: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.COPY_SCOPES_GRID_LAYOUT) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.COPY_SCOPES_GRID_LAYOUT) : null
        });
    },
    onCancel: function () {
        if (typeof this.options.onCancel === 'function') {
            this.options.onCancel();
        }
        this.removeModal();
    },
    onCopy: function () {
        if (typeof this.options.onCopy === 'function') {
            this.options.onCopy(this.selectedProject);
        }
        this.removeModal();
    }
});